import React from 'react';

import classNames from 'classnames';
import { CSVUploadModalProps } from '../utils/csv-uploader.consts';
import Modal from '../../modal/modal';
import CSVUploader from './csv-uploader/csv-uploader';

const CSVUploaderModal = (props: CSVUploadModalProps) => {
	return (
		<Modal
			{...props.modalProps}
			title={props?.texts.title}
			visible
			footer={null}
			onCancel={props.onClose}
			className={classNames('csv-uploader-modal', props.modalProps?.className)}
		>
			<CSVUploader {...props} />
		</Modal>
	);
};

export default CSVUploaderModal;
